module.exports = __webpack_public_path__ + "static/pinkfloralbum3-408a78bea8d1cfa9ed42b97cc505863a.jpeg";